import type { DefaultValues } from 'react-hook-form';
import type { InferType, ObjectSchema } from 'yup';
import type { Nullable } from '@/types/common';

export type SectionSubmitMeta = {
  dirtyFields?: unknown;
};

export type SectionConfig<TKey extends string, TClient, TSchema extends ObjectSchema<object>, TPayload> = {
  key: TKey;
  subtitle: string;
  title: string;
  schema: TSchema;
  mapClientToValues: (client: TClient) => DefaultValues<InferType<TSchema>>;
  mapValuesToPayload: (values: InferType<TSchema>, client?: Nullable<TClient>, meta?: SectionSubmitMeta) => TPayload;
  useOnSave: () => (payload: TPayload) => Promise<void>;
  errorFieldPrefix?: string;
  Fields: React.FC;
};

export const ModalKeys = {
  basic_info: 'basic_info',
  related_basic_info: 'related_basic_info',
  primary_address: 'primary_address',
  related_address: 'related_address',
  related_contact_info: 'related_contact_info',
  emergency_contact: 'emergency_contact',
  loyalty_programs: 'loyalty_programs',
  important_dates: 'important_dates',
  important_travel_data: 'important_travel_data',
  allergies: 'allergies',
  related_allergies: 'related_allergies',
  related_comfort_details: 'related_comfort_details',
  flight_preferences: 'flight_preferences',
  travel_preferences_by_category: 'travel_preferences_by_category',
} as const;

export type ModalKey = (typeof ModalKeys)[keyof typeof ModalKeys];
